import { Component, Input } from '@angular/core';
import { RepairDto } from 'src/app/auto-generated-server-dtos/adjuster/claim/repairs/models/repair-dto';

@Component({
  selector: 'app-repair-work-items',
  templateUrl: './repair-work-items.component.html',
  styleUrl: './repair-work-items.component.scss'
})
export class RepairWorkItemsComponent {
  @Input() repairsDto!: RepairDto[];

}
